import React from 'react';
import { FormattedDate } from 'react-intl';
import { useTranslations } from '@lang';
import { GuestDetail } from 'shared-types/Common';
import { DateContainer, GuestsContainer, SpaDetailsContainer } from './SpaMetadata.styles';
import { DetailTitle } from '../../styled';

type SpaMetadataProps = {
  guestDetails?: Array<GuestDetail> | null;
  checkIn;
  hideArrivalTimes?: boolean;
};

export const SpaMetadata: React.FC<SpaMetadataProps> = ({
  guestDetails,
  checkIn,
  hideArrivalTimes = false,
}) => {
  const { t } = useTranslations();

  return (
    <SpaDetailsContainer>
      <GuestsContainer>
        <DetailTitle>{t('common.guests')}</DetailTitle>
        <div>
          {t('common.numberOfGuests', { guestsAmount: guestDetails ? guestDetails.length : 0 })}
        </div>
      </GuestsContainer>
      <DateContainer>
        <DetailTitle>{t('common.date')}</DetailTitle>
        <div>
          <FormattedDate value={checkIn} month="long" day="numeric" year="numeric" />
        </div>
      </DateContainer>
      {!hideArrivalTimes && (
        <DateContainer>
          <DetailTitle>{t('common.time')}</DetailTitle>
          <FormattedDate value={checkIn} hour="numeric" minute="numeric" />
        </DateContainer>
      )}
    </SpaDetailsContainer>
  );
};
